











































import { Component, Prop, Vue } from "vue-property-decorator";

import { DateHelper } from "@/helper/dateHelper";
import { CookieHelper } from "@/helper/cookieHelper";
import { ResourceHelper } from "@/helper/resourceHelper";

import { UserConfigColors } from "@/userConfigColors/userConfigColors";

import CheckOn from "./resources/checkOn.vue";
import SelectPageTutorial from "./resources/selectPageTutorial.vue";
import SelectTemplateTutorial from "./resources/selectTemplateTutorial.vue";
import DesignEditorTutorial from "./resources/designEditorTutorial.vue";
import LayoutEditorTutorial from "./resources/layoutEditorTutorial.vue";
import PrintSettingTutorial from "./resources/printSettingTutorial.vue";
import SelectInsertionDesignTutorial from "./resources/selectInsertionDesignTutorial.vue";
import InsertionEditorTutorial from "./resources/insertionEditorTutorial.vue";
import InsertionLayoutEditorTutorial from "./resources/insertionLayoutEditorTutorial.vue";

@Component({
  components: {
      CheckOn,
      SelectPageTutorial,
      SelectTemplateTutorial,
      DesignEditorTutorial,
      LayoutEditorTutorial,
      PrintSettingTutorial,
      SelectInsertionDesignTutorial,
      InsertionEditorTutorial,
      InsertionLayoutEditorTutorial
  }
})
export default class Tutorial extends Vue {
    ischeck = false;

    mounted()
    {
        // モーダル表示モード: ON
        this.$store.getters.applicationState.modalMode = 1;
    }

    destroyed()
    {
        // モーダル表示モード: OFF
        this.$store.getters.applicationState.modalMode = 0;
    }

    private get disabled() {
        return process.env.VUE_APP_TUTORIAL === 'off';
    }

    private close(){
        if(this.currentRoute.name == 'selectPage'){
            CookieHelper.setItem("selectPageTutorial", this.ischeck);
        }
        else if(this.currentRoute.name == 'selectTemplate'){
            CookieHelper.setItem("selectTemplateTutorial", this.ischeck);
        }
        else if(this.currentRoute.name == 'DesignEditor'){
            CookieHelper.setItem("designEditorTutorial", this.ischeck);
        }
        else if(this.currentRoute.name == 'LayoutEditor' && this.applicationState.flowMode == 0){
            CookieHelper.setItem("layoutEditorTutorial", this.ischeck);
        }
        else if(this.currentRoute.name == 'PrintSetting'){
            CookieHelper.setItem("printSettingTutorial", this.ischeck);
        }
        else if(this.currentRoute.name == 'selectInsertionDesign'){
            CookieHelper.setItem("selectInsertionDesignTutorial", this.ischeck);
        }
        else if(this.currentRoute.name == 'InsertionEditor'){
            CookieHelper.setItem("insertionEditorTutorial", this.ischeck);
        }
        else if(this.currentRoute.name == 'LayoutEditor' && (this.applicationState.flowMode == 1 || this.applicationState.flowMode == 2)){
            CookieHelper.setItem("insertionLayoutEditorTutorial", this.ischeck);
        }

        this.$emit("close");
    }

    private get title(){
        var title = "";
        if(this.currentRoute.name == 'selectPage'){ title = "用紙選択"; }
        else if(this.currentRoute.name == 'selectTemplate'){ title = "テンプレート"; }
        else if(this.currentRoute.name == 'DesignEditor'){ title = "デザイン編集"; }
        else if(this.currentRoute.name == 'LayoutEditor'){ title = "レイアウト"; }
        else if(this.currentRoute.name == 'PrintSetting'){ title = "印刷"; }
        else if(this.currentRoute.name == 'selectInsertionDesign'){ title = "デザインの選択"; }
        else if(this.currentRoute.name == 'InsertionEditor'){ title = "差し込み"; }
        return title;
    }

    private get currentRoute(){
        return this.$router.currentRoute;
    }

    private get applicationState(){
        return this.$store.getters.applicationState;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }

    //configcolor
    private get userConfigColors() : UserConfigColors{
        return this.$store.getters.userConfigColors;
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private get buttonColorStyle(){
        return {
            "background-color" : this.userConfigColors.buttonColorCode
        };
    }
}
